import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const LoyaltyInsiderLogoBlack: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--loyalty-insider-logo-icon')}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g fill="none" fillRule="evenodd">
      <circle fill="#000" cx="12" cy="12" r="8" />
    </g>
  </svg>
);

export default LoyaltyInsiderLogoBlack;
